export default __webpack_public_path__ + "static/media/team-generator.ed038717.gif";